export enum ProductionType {
  JB = 1,
  Vendor2 = 2
}

export enum PredictionType {
  Prediction = 1,
  ClassPrediction = 2
}

export const ProductionTypeLabels = {
  [ProductionType.JB]: "JB",
  [ProductionType.Vendor2]: "Vendor 2"
};

export const PredictionTypeLabels = {
  [PredictionType.Prediction]: "Prediction",
  [PredictionType.ClassPrediction]: "Class Prediction"
};


